<script setup>
import { getCurrentInstance, onMounted, reactive, ref, watch } from "vue";
import StationInfo from "./stationInfo.vue";
import CameraPage from "./cameraPage.vue";
import GiantPage from "./giantPage.vue";
import FirmInfo from "./firmInfo.vue";

import { queryOrgTree, queryCameraByPlantId } from "@/api/stationBaseInfo";

const { proxy } = getCurrentInstance();
// 页面标题
const title = ref("配置管理");

// 关键字筛选
const filterText = ref(null);

// 树
const plantsOptions = ref([]);

// 是否展示空状态
const isEmpty = ref(true);

// 厂站信息组件ref
const baseInfoRef = ref(null);

// 树组件配置
const defaultProps = reactive({
  children: "children",
  label: "organizationName",
});

// 树图标
const treeIcon = ref("treeIcon");

// tab组件name
const activeName = ref("baseMsg");

// loading
const loading = ref(false);

// 树结构loading
const treeLoading = ref(false);

// 摄像头配置数量
const cameraTotal = ref(0);

// 查询参数
const dataParams = reactive({
  id: undefined,
  name: undefined,
  type: undefined,
});

// 树组件筛选事件
const filterNode = (value, data) => {
  if (!value) return true;
  return data.organizationName.indexOf(value) !== -1;
};

// 组织树点击事件
const handleNodeClick = (data) => {
  if (["公司", "供水厂", "净水厂"].includes(data.organizationTypeStr)) {
    isEmpty.value = false;
    dataParams.id = data.organizationCode;
    dataParams.name = data.organizationName;
    dataParams.type = data.organizationTypeStr;
  } else {
    isEmpty.value = true;
  }

  if (["供水厂", "净水厂"].includes(data.organizationTypeStr)) {
    getCameraCount(data.organizationCode);
  }
};

// 获取摄像头数量
const getCameraCount = (deptId) => {
  queryCameraByPlantId({
    deptId,
  }).then((res) => {
    cameraTotal.value = res.data.total;
  });
};

// 重置子组件的表单内容
const resetBaseForm = () => {};

// 获取树结构数据
const getOrgTree = () => {
  treeLoading.value = true;
  queryOrgTree({})
    .then((res) => {
      plantsOptions.value = res.data || [];
    })
    .finally(() => {
      treeLoading.value = false;
    });
};

// tabs变化
const tabChange = (val) => {
  console.log(val);
  switch (val) {
    case "baseMsg":
      baseInfoRef.value?.getStationInfo();
      break;
    case "camera":
      proxy.$refs.cameraRef?.getCameraList();
      break;
    case "web":
      break;
  }
};

// 摄像头数量组件事件emit
const returnTotal = (val) => {
  cameraTotal.value = val;
};

onMounted(() => {
  getOrgTree();
});

watch(filterText.value, (newVal) => {
  proxy.$refs.tree.filter(newVal);
});
</script>

<template>
  <zh-table-page v-bind="{ title }">
    <template #left>
      <div class="head-container my-tree" v-loading="treeLoading">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model.trim="filterText"
          clearable
        ></el-input>
        <el-tree
          :data="plantsOptions"
          node-key="organizationCode"
          :props="defaultProps"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          ref="tree"
          default-expand-all
          @node-click="handleNodeClick"
          highlight-current
        >
          <template #default="{ node, data }">
            <span class="custom-tree-node">
              <span>
                {{ node.label
                }}<el-icon v-show="!data.mark" class="treeIcon"
                  ><Warning
                /></el-icon>
              </span>
            </span>
          </template>
        </el-tree>
      </div>
    </template>
    <template #header-btn></template>
    <template #search></template>
    <template #table>
      <el-empty
        v-show="isEmpty"
        :image="require('@/assets/images/none.png')"
        description="请选择公司或厂站"
        style="height: 100%"
        :image-size="200"
      />
      <el-tabs
        v-model="activeName"
        v-show="!isEmpty && ['供水厂', '净水厂'].includes(dataParams.type)"
        @tab-change="tabChange"
        v-loading="loading"
      >
        <el-tab-pane label="厂站信息" name="baseMsg">
          <station-info ref="baseInfoRef" :params="dataParams" />
        </el-tab-pane>
        <el-tab-pane name="camera">
          <template #label>
            <span class="span-box">
              <span>摄像头信息配置</span>
              <el-badge :value="cameraTotal" class="item" type="primary" />
            </span>
          </template>
          <camera-page
            ref="cameraRef"
            :deptId="dataParams.id"
            @returnTotal="returnTotal"
          />
        </el-tab-pane>
        <!-- <el-tab-pane label="物联网账号" name="web">
          <giant-page :deptId="dataParams.id" />
        </el-tab-pane> -->
      </el-tabs>
      <firm-info
        ref="firmRef"
        v-if="!isEmpty && dataParams.type == '公司'"
        :params="dataParams"
      />
    </template>
  </zh-table-page>
</template>

<style lang="scss" scoped>
.treeIcon {
  color: orange;
  padding-left: 5px;
}
</style>
